import React from "react";

import Form from "../Components/SmartForm/Form";
import Input from "../Components/SmartForm/Input";
import Label from "../Components/SmartForm/Label";

const LoginForm = (props) => {

    return (
        <Form
            id="login-form"
            action="/customer/account/login"
            method="post"
            {...props}
        >

            <div className="form-group">
                <Label
                    input="email"
                    required
                >
                    Email Address
                </Label>
                <Input
                    className="form-control"
                    type="email"
                    required
                    name="email"
                    label="Email Address"
                    placeholder="Enter your Email Address"
                />
            </div>

            <div className="form-group">
                <Label
                    input="password"
                    required
                >
                    Password
                </Label>
                <Input
                    className="form-control"
                    type="password"
                    required
                    name="password"
                    placeholder="Enter your Password"
                />
            </div>

            <div className="col-12 d-flex justify-content-between">
                <button
                    className="btn btn-lx"
                    type="submit"
                >
                    <i className="fas fa-lock-alt" />
                    Sign In
                </button>
                <a
                    className="mt-2 d-block"
                    href="/customer/account/forgotPassword"
                >
                    Forgot your password?
                </a>
            </div>
        </Form>
    );
};

export default LoginForm;
